export default "__VITE_ASSET__BldUpnTb__"